export enum TAB_KEY {
    HOURS = 'hours',
    DAYS_1_4 = '1-4days',
    DAYS_5_PLUS = '5days+',
    WHOLE_HOME = '24-7',
}

export interface ImageConfig {
    pc: string;
    h5: string;
}

export interface ConsultCardConfig {
    label: string;
    title: string;
    desc: string;
    btn: string;
    img: ImageConfig;
    href: string;
}

export interface ProductConfig {
    productId: string;
    variantId: string;
    label: string;
    desc: string;
    skuTitle?: string;
}

export interface TabDataConfig {
    tabLabel: string;
    label: string;
    title: string;
    desc: string;
    image: ImageConfig;
    products: ProductConfig[];
    consultCard?: ConsultCardConfig;
}

type TranslateFn = (key: string) => string;

export const getTabsConfig = (t: TranslateFn) => {
    const tabData: Record<TAB_KEY, TabDataConfig> = {
        [TAB_KEY.HOURS]: {
            tabLabel: 'Hours',
            label: t('label1'),
            title: t('title1'),
            desc: t('desc1'),
            image: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767691664174-fwndy3-compressed-full-width-carousel.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767691718817-3is95o-compressed-Frame%202094654867.jpg',
            },
            products: [
                { productId: '7290965622857', variantId: '41636504305737', label: t('i1_product1_label'), desc: t('i1_product1_desc') },
                { productId: '7290968473673', variantId: '41636514136137', label: t('i1_product2_label'), desc: t('i1_product2_desc') },
                { productId: '15386067730505', variantId: '54691871227977', label: t('i1_product5_label'), desc: t('i1_product5_desc') },
                { productId: '7289136054345', variantId: '41826182496329', label: t('i1_product4_label'), desc: t('i1_product4_desc') },
                { productId: '7394893463625', variantId: '42015827492937', label: t('i1_product3_label'), desc: t('i1_product3_desc') },
                { productId: '7323318190153', variantId: '41719074324553', label: t('i1_product6_label'), desc: t('i1_product6_desc') },
            ],
        },
        [TAB_KEY.DAYS_1_4]: {
            tabLabel: '1-4 Days',
            label: t('label2'),
            title: t('title2'),
            desc: t('desc2'),
            image: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767691680678-0ukmhq-compressed-full-width-carousel.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767691729271-qvdowv-compressed-Frame%202094654868.jpg',
            },
            products: [
                { productId: '15386147061833', variantId: '54718699962441', label: t('i2_product5_label'), desc: t('i2_product5_desc') },
                { productId: '6905537888329', variantId: '40538145095753', label: t('i2_product1_label'), desc: t('i2_product1_desc') },
                { productId: '15386143096905', variantId: '54718705008713', label: t('i2_product6_label'), desc: t('i2_product6_desc') },
                { productId: '6585086836809', variantId: '40516140138569', label: t('i2_product2_label'), desc: t('i2_product2_desc') },
                { productId: '7185477075017', variantId: '41385721004105', label: t('i2_product3_label'), desc: t('i2_product3_desc') },
                { productId: '7383152951369', variantId: '41963472289865', label: t('i2_product4_label'), desc: t('i2_product4_desc') },
            ],
        },
        [TAB_KEY.DAYS_5_PLUS]: {
            tabLabel: '5 Days+',
            label: t('label3'),
            title: t('title3'),
            desc: t('desc3'),
            image: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767691691252-987ojg-compressed-full-width-carousel.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767691740655-mntvvq-compressed-Frame%202094654869.jpg',
            },
            products: [
                {
                    productId: '15391292588105',
                    variantId: '54714781171785',
                    label: t('i3_product1_label'),
                    desc: t('i3_product1_desc'),
                    skuTitle: '1 × EcoFlow DELTA Pro Ultra X Inverter + 2 × Smart Extra Battery',
                },
                {
                    productId: '15391292588105',
                    variantId: '54714781204553',
                    label: t('i3_product2_label'),
                    desc: t('i3_product2_desc'),
                    skuTitle: '1 × EcoFlow DELTA Pro Ultra X Inverter + 2 × Smart Extra Battery + 1 × EcoFlow Smart Home Panel 3',
                },
                { productId: '7185477075017', variantId: '41703627980873', label: t('i3_product3_label'), desc: t('i3_product3_desc') },
            ],
        },
        [TAB_KEY.WHOLE_HOME]: {
            tabLabel: '24/7',
            label: t('label4'),
            title: t('title4'),
            desc: t('desc4'),
            image: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767691703014-zspo0b-compressed-full-width-carousel.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767691752586-qtkhiw-compressed-Frame%202094654870.jpg',
            },
            products: [],
            consultCard: {
                label: t('i4_product_label'),
                title: t('i4_product_title'),
                desc: t('i4_product_desc'),
                btn: t('i4_product_btn'),
                img: {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1753067523603/i4-product.png',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1753067523525/i4-product-h5.png',
                },
                href: 'https://www.ecoflow.com/us/ocean-pro-consultation?utm_source=oceanpro&utm_medium=orderpage',
            },
        },
    };

    return Object.entries(tabData).map(([key, data]) => ({
        key: key as TAB_KEY,
        ...data,
    }));
};
